import { BrowserRouter, Routes, Route, Navigate } from 'react-router'
import { useAuth } from '@/hooks/useAuth'
import Layout from '@/components/layout/Layout'
import LoginPage from '@/app/routes/login'
import DashboardPage from '@/app/routes/dashboard'
import TenantsPage from '@/app/routes/tenants'
import TenantDetailPage from '@/app/routes/tenants.$id'
import JobsPage from '@/app/routes/jobs'
import AuditPage from '@/app/routes/audit'
import SettingsPage from '@/app/routes/settings'
import SecretsPage from '@/app/routes/secrets'
import NewTenantPage from '@/app/routes/tenants.new'

// ── Auth guard ─────────────────────────────────────────────────────────────

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

// ── Root routes ────────────────────────────────────────────────────────────

export default function Root() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="tenants" element={<TenantsPage />} />
          <Route path="tenants/new" element={<NewTenantPage />} />
          <Route path="tenants/:id" element={<TenantDetailPage />} />
          <Route path="jobs" element={<JobsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="secrets" element={<SecretsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
